export default "__VITE_ASSET__GeU3xoXw__"